module.exports = __webpack_public_path__ + "img/202506_03.d3a3a797.jpg";